import { Configuration, SuppliersApi } from '@/api';
import useGetOrganizationQuery from '@/api/queries/useGetOrganizationQuery';
import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import PageHeader from '@/components/PageHeader';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierToStoreForm, {
  SupplierToStore,
} from '@/modules/admin/components/SupplierToStoreForm';
import { SupplierToStoreListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

const SupplierToStoreAdd = () => {
  const navigate = useNavigate();

  const { supplierId } = useParams();

  const auth = useAuth();

  const suppliersApi = new SuppliersApi(new Configuration(useAuth));

  const { isLoading: isLoadingSupplier, supplier } = useGetSupplierQuery(supplierId, auth);

  const { isLoading: isLoadingOrganization, organization } = useGetOrganizationQuery(
    supplier?.organizationId,
    auth,
  );

  if (isLoadingSupplier || isLoadingOrganization) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!supplier) {
    return;
  }

  const handleOnSubmit = async (data: SupplierToStore): Promise<void> => {
    if (!supplierId || !data.store) return;

    await suppliersApi.addStoresToSupplier(supplierId, [
      {
        id: data.store.id,
        customerCode: data.customerCode,
        moq: data.moq,
      },
    ]);

    toast.custom((t) => (
      <CustomToast id={t.id} message="Store added successfully!" visible={t.visible} />
    ));

    navigate(SupplierToStoreListPath.withSupplierId(supplierId));
  };

  return (
    <div>
      <Breadcrumbs />

      <PageHeader title="Link Store" />

      <div className="bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <SupplierToStoreForm
          supplier={supplier}
          organization={organization}
          onSubmit={handleOnSubmit}
        />
      </div>
    </div>
  );
};

export default SupplierToStoreAdd;
